import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { activityQueryKeys } from "./activityQueryKeys";

export function useMutationActivityCategoryCreate({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (
      newActivity: Parameters<ApiType["activityApi"]["createCategory"]>[0],
    ) => {
      const response = await api.activityApi.createCategory(newActivity);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: activityQueryKeys.categories(),
      });
    },
  });

  return mutation;
}
